import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
//@ts-ignore
import { getSingleElement } from "@utils/DOMUtils";
//@ts-ignore
import { getPreviousNextRealEstate, getPreviousNextRealEstateDirect } from "@services/realEstateAPI";
var pagination;
var realEstate = window["_serializedRealEstateBean"] ? JSON.parse(window["_serializedRealEstateBean"]) : null;
export function create(count, pageSize, currentPage, page, searchBean, backURL) {
  var pagination = {
    count: count,
    pageSize: pageSize,
    backURL: backURL,
    pages: {
      [currentPage]: page
    },
    fromListing: true,
    direct: false,
    searchBean: searchBean
  };
  localStorage.setItem("pagination", JSON.stringify(pagination));
}
export function initPagination() {
  var fromMap;
  //Matteo C.: fix per quando si arriva dall'area pro, Chrome non permette di usare l'opener se si arriva da un dominio diverso
  try {
    fromMap = window.opener && window.opener.location.hash === "#map";
  } catch (_a) {
    fromMap = false;
  }
  var promises = [
  // Andrea M: da listato / mappa, ho già l'oggetto pagination
  () => new Promise(resolve => {
    var obj = localStorage.getItem("pagination");
    if (!obj) resolve(null);else {
      var _pagination = JSON.parse(obj);
      resolve(_pagination);
    }
  }),
  // Andrea M: accesso diretto, devo chiamare la pagination direct
  () => __awaiter(this, void 0, void 0, function* () {
    if (!realEstate) return null;
    var searchBean = buildSearchBeanFromRealEstate(realEstate);
    try {
      var _pagination2 = yield getPreviousNextRealEstateDirect(searchBean);
      if (!_pagination2) {
        return null;
      }
      _pagination2.direct = true;
      return _pagination2;
    } catch (err) {
      console.error(err);
      return null;
    }
  })];
  return new Promise((resolve, reject) => {
    // Andrea M: eseguo le promise in ordine per ottenere l'oggetto pagination
    //Short-circuit on first pagination found
    promises.reduce((acc, fn) => __awaiter(this, void 0, void 0, function* () {
      var data = yield acc;
      return data ? data : fn();
    }), Promise.resolve(null)).then(pagination => {
      var _a, _b;
      if (!pagination) {
        reject("No pagination object found");
        return;
      }
      pagination.fromMap = fromMap;
      // Andrea M: controllo se l'immobile corrente è già nelle pagine o è in testa, se non c'è lo metto in testa
      if (!pagination.head && (pagination === null || pagination === void 0 ? void 0 : pagination.pages)) {
        var found = (_a = Object.keys(pagination.pages)) === null || _a === void 0 ? void 0 : _a.some(key => {
          var page = pagination.pages[parseInt(key)];
          return page === null || page === void 0 ? void 0 : page.some(re => re.id === window["_referenceId"]);
        });
        if (!found) {
          pagination.head = window["_referenceId"] || 0;
          (_b = pagination.pages[1]) === null || _b === void 0 ? void 0 : _b.unshift({
            id: window["_referenceId"],
            url: window["_canonicalURL"]
          });
        }
      }
      localStorage.setItem("pagination", JSON.stringify(pagination));
      resolve(pagination);
    });
  });
}
export var getPagination = () => pagination;
export function writePagination(pagination) {
  localStorage.setItem("pagination", JSON.stringify(pagination));
}
export function init() {
  return __awaiter(this, void 0, void 0, function* () {
    try {
      var data = yield initPagination();
      if (!data) {
        hidePagination();
        return;
      }
      pagination = data;
      var pagesNumber = Object.keys(pagination.pages);
      //In this case, we selected the last real estate insertion of a list of insertions with size equal to 25
      //If we are in the last page, it's pointless to get another page since there won't be any
      if (pagesNumber.length < 2 && pagination.idx === pagination.pageSize - 1 && parseInt(pagesNumber[0] + 1) * pagination.pageSize < pagination.count) {
        //Getting the next page
        yield getPage(parseInt(pagesNumber[0]) + 1, pagination.searchBean);
      }
      //In this case, we selected the first real estate insertion of a list of insertions with size equal to 25
      //If we are in the very first page, we won't do get any prev page
      else if (pagesNumber.length < 2 && !pagination.idx && parseInt(pagesNumber[0]) > 1) {
        //Getting the prev page
        yield getPage(parseInt(pagesNumber[0]) - 1, pagination.searchBean);
      }
      var flattenedPages = [];
      //Flattening the pages
      for (var k in pagination.pages) {
        var v = pagination.pages[k];
        for (var insertion of v) {
          flattenedPages.push(Object.assign(Object.assign({}, insertion), {
            pageNumber: parseInt(k)
          }));
        }
      }
      //Removing duplicates
      flattenedPages = flattenedPages.reduce((acc, cur, idx) => {
        var _idx = acc.length ? ((acc[acc.length - 1].idx || 0) + 1) % pagination.pageSize : idx;
        return acc.find(i => i.id === cur.id) ? acc : [...acc, Object.assign(Object.assign({}, cur), {
          idx: _idx
        })];
      }, []);
      var index = flattenedPages.findIndex(i => i.id === window["_referenceId"]);
      if (index >= 0) {
        var curInsertion = flattenedPages[index];
        draw(curInsertion.idx || 0, curInsertion.pageNumber, pagination.count, getPrevURL(index, flattenedPages), getNextURL(index, flattenedPages), pagination.backURL);
      } else hidePagination();
    } catch (err) {
      console.error("Cannot create pagination object");
      console.log(err);
      hidePagination();
    }
  });
}
function getPrevURL(index, insertionList) {
  return index > 0 ? insertionList[index - 1].url : "";
}
function getNextURL(index, insertionList) {
  return index <= insertionList.length - 2 ? insertionList[index + 1].url : "";
}
function hidePagination() {
  getSingleElement("#pagination").remove();
}
function draw(index, pageNumber, count, prevURL, nextURL, backURL) {
  var position;
  // Andrea M: se non è paginazione diretta la posizione è semplicemente il numero di pagina - 1 per
  // 20 + l'indice + 1 (perchè l'indice è 0-indexed).
  // Se invece è paginazione diretta devo sommare la lunghezza delle pagine precedenti a quella a
  // in cui sono, perchè la prima pagina è di 21 elementi (l'elemento direct è in testa) e può essere
  // presente una pagina di 19 elementi (la pagina che realmente contiene l'elemento direct)
  if (!pagination.head) position = (pageNumber - 1) * pagination.pageSize + index + 1;else position = Object.keys(pagination.pages).filter(key => parseInt(key) < pageNumber).reduce((acc, page) => acc + pagination.pages[Number(page)].length, 0) + index + 1;
  var positionEl = getSingleElement("#position");
  var prevReEl = getSingleElement("#prevRE");
  var nextReEl = getSingleElement("#nextRE");
  // convert in string only for the showing data
  var positionThousand = position.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  var countThousand = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  positionEl.innerHTML = "<span class=\"font-weight-semibold\">".concat(positionThousand, "</span>/").concat(countThousand);
  if (prevURL) prevReEl.setAttribute("href", String(prevURL));else prevReEl.remove();
  //TODO: da fixare lato back in quanto non dovrebbe essere possibile avere altri immobili se si è già all'ultimo del listato
  if (nextURL && position < count) nextReEl.setAttribute("href", String(nextURL));else nextReEl.remove();
}
function getPage(pageNumber, searchBean) {
  return __awaiter(this, void 0, void 0, function* () {
    var page = yield getPreviousNextRealEstate(searchBean, pageNumber);
    if (!page) {
      return;
    }
    // Andrea M: se ho un immobile in testa e lo trovo nella pagina successiva lo tolgo dalla pagina
    if (pagination.head) page = page.filter(re => re.id !== pagination.head);
    //We are not just insering the new page to the pages object... but we are also inserting in an ASC order the keys!
    pagination.pages[pageNumber] = page;
    localStorage.setItem("pagination", JSON.stringify(pagination));
  });
}
export function find(pagination, id) {
  return Object.keys(pagination.pages).some(key => {
    // @ts-ignore
    return pagination.pages[key].some(item => {
      return item.id === id;
    });
  });
}
function buildSearchBeanFromRealEstate(realEstate) {
  if (!realEstate) return {};
  return {
    id: realEstate.id,
    sale: realEstate.sale,
    rent: realEstate.rent,
    auctionType: realEstate.auction ? 1 : 0,
    macroTypologyId: realEstate.macroTypologyID,
    cityId: realEstate.cityID,
    typologyId: realEstate.typologyType,
    localityIdList: realEstate.localityID ? [realEstate.localityID] : undefined,
    zoneIdList: realEstate.zoneID ? [realEstate.zoneID] : undefined
  };
}